import { yupResolver } from '@hookform/resolvers/yup';
import { CustomButton, CustomInputCheckBox, CustomInputSelect, CustomTextInput } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { IOperationMeta } from '@Modules/cardManagementSystem/smart/containers/formHandlers/globalParameters/scriptProcessingParameters/operation/OperationMeta';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';

type Props = {
  meta: IOperationMeta,
} & TFormUIProps;

export const OperationFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema),});

  
  return (
    <>
      <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
        <CC.Flex
          direction={{  base: 'column' }}
          gap={"16px"}
          mt={"20px"}
        >
          <CC.SimpleGrid columns={{ base:1, }} gridRowGap={4} columnGap={10} my={4}>
            {displayCustomInputs(
              meta,
              register,
              errors,
              isLoading
            )}
          </CC.SimpleGrid>


        </CC.Flex>

        <CC.Flex justify={'end'} mt={'1em'}>
          <CustomButton isLoading={isSubmitting} type='submit'>
            <FaSave style={{marginRight: '10px'}} /> 
            Enregistrer
          </CustomButton>
        </CC.Flex>
      
      </CC.Box>
    </>
  )
}